import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-us",
    component: _cffe3db6,
    name: "contact-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/about-us/community-involvement",
    component: _cffe3db6,
    name: "community-involvement"
  }, {
    path: "/about-us/our-approach",
    component: _cffe3db6,
    name: "our-approach"
  }, {
    path: "/about-us/our-team",
    component: _cffe3db6,
    name: "our-team"
  }, {
    path: "/about-us/strategic-alliances",
    component: _cffe3db6,
    name: "strategic-alliances"
  }, {
    path: "/expertise/key-services",
    component: _cffe3db6,
    name: "key-services"
  }, {
    path: "/expertise/our-typical-clients",
    component: _cffe3db6,
    name: "our-typical-clients"
  }, {
    path: "/resources/7fdf74ad-f46d-46a3-a038-46239e4c107a",
    component: _cffe3db6,
    name: "7fdf74ad-f46d-46a3-a038-46239e4c107a"
  }, {
    path: "/resources/blog",
    component: _cffe3db6,
    name: "blog"
  }, {
    path: "/resources/news-and-press",
    component: _cffe3db6,
    name: "news-and-press"
  }, {
    path: "/resources/our-investment-resource",
    component: _cffe3db6,
    name: "our-investment-resource"
  }, {
    path: "/resources/your-information",
    component: _cffe3db6,
    name: "your-information"
  }, {
    path: "/about-us/our-team/chris-a",
    component: _cffe3db6,
    name: "chris-a"
  }, {
    path: "/about-us/our-team/courtney-a-robshaw",
    component: _cffe3db6,
    name: "courtney-a-robshaw"
  }, {
    path: "/about-us/our-team/david-j",
    component: _cffe3db6,
    name: "david-j"
  }, {
    path: "/about-us/our-team/jim-e",
    component: _cffe3db6,
    name: "jim-e"
  }, {
    path: "/about-us/our-team/josh-m",
    component: _cffe3db6,
    name: "josh-m"
  }, {
    path: "/about-us/our-team/marc-r",
    component: _cffe3db6,
    name: "marc-r"
  }, {
    path: "/about-us/our-team/matt-turco",
    component: _cffe3db6,
    name: "matt-turco"
  }, {
    path: "/about-us/our-team/michelle-b",
    component: _cffe3db6,
    name: "michelle-b"
  }, {
    path: "/about-us/our-team/scott-z",
    component: _cffe3db6,
    name: "scott-z"
  }, {
    path: "/about-us/our-team/shelly-laboy",
    component: _cffe3db6,
    name: "shelly-laboy"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
